// extracted by mini-css-extract-plugin
module.exports = {"container":"_2RaED6r-axPqu5bv_xUnrX"};